import React, { useEffect, useState, useContext } from 'react';

import APICtx from '#api'
import Form, { FileUpload, Input, Select } from '#Form'
import { delegheTypes } from './def';

export default function CampaignEdit({ _id }) {
	const api = useContext(APICtx)
	const [ zones, setZones ] = useState([])

	const formDef = {
		_id,
		callSet: _id ? "mailer/f24/update" : "mailer/f24/create",
		callGet: _id && "mailer/f24/get",
	}

	useEffect(() => {
		api.auth.groupsAsOptions({ acl:'mailer-deleghe-zone' }).then(opts => {
			setZones(opts.filter(opt => api.auth.groups.includes(opt.address)))
		})
	}, [])

	const isRO = Boolean(_id)

	return (
		<Form {...formDef}>
			<Input name="mailSubject" label="Email - oggetto" />
			<Input name="mailContent" label="Email - testo" multiline />
		</Form>
	)
}
